$(document).ready(function () {

  /*** contact form logic ***/

  // hide cities and facilities fields
  // $('.populate_cities').hide();
  // $('.populate_facilities').hide();

  // on state change
  $('.populate_states select').on('change', function() {
    var state = $(this).val();

    console.log('state:', state);

    if (state == '') {
      // hide cities and facilities fields
      // $('.populate_cities').slideUp();
      // $('.populate_facilities').slideUp();
      // reset cities, show all options
      $('.populate_cities option.gf_placeholder').prop('selected', true);
      $('.populate_cities option').show();
      // reset facilities, show all options
      $('.populate_facilities option.gf_placeholder').prop('selected', true);
      $('.populate_facilities option').show();
    } else {
      // hide facilities field
      // $('.populate_facilities').slideUp();
      // show cities field
      // $('.populate_cities').slideDown();
      // reset states
      $('.populate_cities option.gf_placeholder').prop('selected', true);
      $('.populate_cities option:not(.gf_placeholder)').hide();
      $('.populate_cities option[data-state="' + state + '"]').show();
      // reset facilities
      $('.populate_facilities option.gf_placeholder').prop('selected', true);
      $('.populate_facilities option:not(.gf_placeholder)').hide();
      $('.populate_facilities option[data-state="' + state + '"]').show();
    }
  });

  // on city change
  $('.populate_cities select').on('change', function() {
    var city = $(this).val();

    console.log('city:', city);

    if (city == '') {
      // hide facilities field
      // $('.populate_facilities').slideUp();
      // reset facilities, show all options
      $('.populate_facilities option.gf_placeholder').prop('selected', true);
      $('.populate_facilities option').show();
    } else {
      // get state to go with city
      var state = $('option:selected', this).attr('data-state');
      // show facilities field
      // $('.populate_facilities').slideDown();
      // reset facilities
      $('.populate_facilities option.gf_placeholder').prop('selected', true);
      $('.populate_facilities option:not(.gf_placeholder)').hide();
      $('.populate_facilities option[data-state="' + state + '"][data-city="' + city + '"]').show();
    }
  });

  /*** prevent clicks on menu parents ***/
  $('.primary-nav a[href="#"]').click(function (e) {
    e.preventDefault();
  });

  /*** smooth scrolling to anchors ***/
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500);
      }
    }
  });

  /*** home page functionality ***/
  if ($('body').hasClass('page-template-page-pro-home')) {

    // get local timezone
    var today = new Date();
    var timezoneOffset = today.getTimezoneOffset();
    var offset = (timezoneOffset * 60) * -1;
    $('#address').attr('data-offset', offset);

    autocomplete();
    initialSearchForm();
  }

  /*** blog categories select nav ***/
  $('#pro-categories-nav').on('change', function () {
    var url = this.value;
    if (url.length > 0) {
      window.location.href = url;
    }
  });

  /*** mobility page ***/

  if ($('body').hasClass('page-template-page-pro-mobility')) {

    var video = $('.pro-mobility-header-video video');

    var sections = $('.pro-mobility-section');
    if (sections) {
      var observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pro-mobility-section-active');
            // observer.unobserve(entry.target);
            if (entry.target.id == 'mobility-solutions') {
              console.log('#mobility-solutions is intersecting');
              $(video).trigger('pause');
            }
          } else {
            entry.target.classList.remove('pro-mobility-section-active');
            if (entry.target.id == 'mobility-solutions') {
              console.log('#mobility-solutions not intersecting');
              $(video).trigger('play');
            }
          }
        });
      }, { threshold: [0.5] });
    }

    $(sections).each(function (index, section) {
      observer.observe(section);
    });

    if ($('.pro-mobility-section-sustainable-headline-predicate').length > 1) {

      var slider = $('.pro-mobility-section-sustainable-headline-predicates-slider');

      var pause = $(slider).attr('data-pause');
      var speed = $(slider).attr('data-speed');

      var wordSlider = $(slider).bxSlider({
        mode: 'vertical',
        auto: false,
        autoHover: true,
        controls: false,
        pager: false,
        pause: pause,
        speed: speed
      });

      var observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            wordSlider.startAuto();
          } else {
            wordSlider.stopAuto();
          }
        });
      }, { threshold: [0.5] });
      var target = document.querySelector('.pro-mobility-section-sustainable-headline-predicates');
      observer.observe(target);

    }

    $('.pro-mobility-campus-item-image').hover(function () {
      $('.pro-mobility-campus').toggleClass('pro-mobility-campus-active');
      var id = $(this).parent().attr('id');
      $('#' + id + ' .pro-mobility-campus-item-text').toggleClass('pro-mobility-campus-item-text-active');
    });

  }

  if ($('body').hasClass('page-template-page-pro-mobility-new')) {

    if ($('.pro-mob-ticker-marquee').children().length > 1) {

      var pause = $('.pro-mob-ticker-marquee').attr('data-pause');
      var speed = $('.pro-mob-ticker-marquee').attr('data-speed');

      var marquee = $('.pro-mob-ticker-marquee').bxSlider({
        mode: 'fade',
        auto: true,
        autoHover: true,
        controls: false,
        pager: false,
        pause: pause,
        speed: speed
      });

    }

    $('.pro-mob-campus-imagemap-item img').hover(function () {
      var parent = $(this).parent();
      var id = $(parent).attr('data-id');
      $(parent).toggleClass('pro-mob-campus-imagemap-item-active');
      $('.pro-mob-campus-imagemap-item').not(parent).toggleClass('pro-mob-campus-imagemap-item-dimmed');
      $('.pro-mob-campus-imagemap-background').toggleClass('pro-mob-campus-imagemap-background-dimmed');
      $('.pro-mob-campus-item[data-id="' + id + '"]').toggleClass('pro-mob-campus-item-active');
    });

    $('.pro-mob-campus-item-title').on('click', function () {
      var width = $(window).width();
      console.log(width);
      if (width < 800) {
        $(this).parent().toggleClass('pro-mob-campus-item-active');
      }
    });

    var sections = $('.pro-mob-section');
    if (sections) {
      var observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {

          if (entry.isIntersecting) {

            entry.target.classList.add('pro-mob-section-active');
            if (entry.target.classList.contains('pro-mob-section-campus')) {

            } else if (entry.target.classList.contains('pro-mob-section-cards')) {

            } else if (entry.target.classList.contains('pro-mob-section-form')) {

            } else if (entry.target.classList.contains('pro-mob-section-hero')) {

              console.log('play!');
              $('.pro-mob-hero-video').trigger('play');

            } else if (entry.target.classList.contains('pro-mob-section-logos')) {

            } else if (entry.target.classList.contains('pro-mob-section-ticker')) {

              if ($('.pro-mob-ticker-marquee').children().length > 1) {
                marquee.startAuto();
              }

            }
          } else {

            entry.target.classList.remove('pro-mob-section-active');
            if (entry.target.classList.contains('pro-mob-section-campus')) {

            } else if (entry.target.classList.contains('pro-mob-section-cards')) {

            } else if (entry.target.classList.contains('pro-mob-section-form')) {

            } else if (entry.target.classList.contains('pro-mob-section-hero')) {

              console.log('pause!');
              $('.pro-mob-hero-video').trigger('pause');

            } else if (entry.target.classList.contains('pro-mob-section-logos')) {

            } else if (entry.target.classList.contains('pro-mob-section-ticker')) {

              if ($('.pro-mob-ticker-marquee').children().length > 1) {
                marquee.stopAuto();
              }

            }
          }
        });
      }, { threshold: [0.5] });

      $(sections).each(function (index, section) {
        observer.observe(section);
      });
    }

  }

  if ($('.pro-parking-people-slider').length > 0) {
    var people = $('.pro-parking-people-slider').bxSlider({
      mode: 'horizontal',
      pager: false,
      controls: true,
      minSlides: 1,
      maxSlides: 4,
      moveSlides: 1,
      slideWidth: 320,
      slideMargin: 16,
      shrinkItems: true,
      infiniteLoop: true
    });

  }

  $('.pro-parking-person').on('click', function (e) {
    e.preventDefault();

    var gallery = $(this).attr('data-gallery');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'parking_person_modal',
        gallery: gallery
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);

        if (results.status === 'success') {
          var modal = $($('#pro-modal').html());
          $('.pro-modal-content', modal).append('<div class="pro-modal-images-slider"></div>');
          if (results.images) {
            var images = results.images;
            $(images).each(function (index, image) {
              $('.pro-modal-images-slider', modal).append('<div class="pro-modal-images-slide"><img src="' + image + '" alt="" /></div>');
            });
          }

          $('body').addClass('pro-modal-active').append(modal);

          // close modal on ESC key press
          $(document).keydown(function (e) {
            if (e.keyCode == 27) {
              $('body').removeClass('pro-modal-active');
              $('.pro-modal').remove();
            }
          });

          $('.pro-modal-images-slider', modal).bxSlider({
            mode: 'horizontal',
            pager: false,
            controls: true,
            adaptiveHeight: true,
            infiniteLoop: true
          });

        } else if (results.status === 'error') {
          // uh oh
        } else {
          // something else happened?
        }

      },
      error: function (results) {
        console.log(results);
      }
    });

  });

  if ($('.pro-videos-slider').length > 0) {

    var videos = $('.pro-videos-slider').bxSlider({
      mode: 'horizontal',
      pager: false,
      controls: true,
      minSlides: 1,
      maxSlides: 3,
      moveSlides: 1,
      slideWidth: 480,
      slideMargin: 16,
      shrinkItems: true,
      infiniteLoop: true
    });
  }

  // show video in modal
  $('.pro-card-video-link, .pro-videos-slider-video').on('click', function (e) {
    e.preventDefault();
    var host = $(this).attr('data-host');
    var id = $(this).attr('data-id');
    var modal = $($('#pro-modal').html());
    if (host === 'vimeo') {
      var embed = '<iframe src="https://player.vimeo.com/video/' + id + '?" width="560" height="315" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    } else if (host === 'youtube') {
      var embed = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }
    $('.pro-modal-content', modal).append('<div class="pro-modal-video-embed">' + embed + '</div>');
    $('body').addClass('pro-modal-active').append(modal);
    // close modal on ESC key press
    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        $('body').removeClass('pro-modal-active');
        $('.pro-modal').remove();
      }
    });
  });

  // close an opened modal
  $('body').on('click', '.pro-modal-close', function (e) {
    e.preventDefault();
    $('body').removeClass('pro-modal-active');
    $(this).parent().remove();
  })

  if ($('.pro-instagram-feed').length > 0) {

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'get_instagram_api_access_token'
      },
      success: function (results) {
        var results = JSON.parse(results);
        // console.log(results);
        if (results.status === 'success' && results.token) {

          var feeds = $('.pro-instagram-feed');
          $(feeds).each(function (index, feed) {
            var instafeed = new Instafeed({
              debug: true,
              target: feed,
              limit: 9,
              template: '<a href="{{link}}" target="_blank" title="{{caption}}" class="pro-instagram-image"><img title="{{caption}}" src="{{image}}" /></a></div>',
              accessToken: results.token,
              success: function () {
                $(feed).addClass('pro-instagram-feed-loaded');
              }
            });
            instafeed.run();
          });

        } else {

        }
      },
      error: function (results) {

      }
    });
  }

  /*** load more resources cards ***/
  $('#load-more-resources').on('click', function(e){
    e.preventDefault();

    var this_button = $(this);

    $(this_button).prop('disabled', true);

    var offset = $('.pro-resources-card').length;
    var post_types = $(this_button).attr('data-post-types');
    var categories = $(this_button).attr('data-categories');
    var content_types = $(this_button).attr('data-content-types');
    var taxonomy = $(this_button).attr('data-taxonomy');
    var term_id = $(this_button).attr('data-term-id');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'pro_load_more_resources_cards',
        offset: offset,
        post_types: post_types,
        categories: categories,
        content_types: content_types,
        taxonomy: taxonomy,
        term_id: term_id
      },
      success: function(results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.status === 'success') {
          $('.pro-resources-cards-group').append(results.template);
          if (results.post_count < 9) {
            $(this_button).hide();
          }
        }
        $(this_button).prop('disabled', false);
      },
      error: function(results) {
        // var results = JSON.parse(results);
        console.log(results);
        $(this_button).prop('disabled', false);
      }
    });
  });

  /*** resources filter dropdowns ***/
  $('#blog-categories, #content-types').on('change', function(){
    var url = $(this).val();
    window.location.href = url;
  });

  /*** 2.0 accordions ***/
  $('.pro2-section-alternating-content-accordion-title').on('click', function() {
    $(this).parent().toggleClass('pro2-section-alternating-content-accordion-active');
  });

});
